import styles from './jenjang.module.css'

import clsx from 'clsx'

import { Shimmer } from '@wartek-id/shimmer'

import { range } from '@/utils/array'

export const JenjangStatsLoader = () => {
  return (
    <div
      className={clsx(
        'mt-4 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 lg:flex lg:grid-cols-10',
        styles.jenjangStatsWrapper
      )}
    >
      {range(1, 10).map((item) => (
        <div key={item}>
          <Shimmer width={80} height={15} className="mb-1" />
          <Shimmer width={50} height={15} />
        </div>
      ))}
    </div>
  )
}
